import { OpenModal as UsecaseReduxOpenModal } from 'domain/usecases/modal/redux';

import { ReduxOpenModal } from 'data/store/reducer/modal/usecases';

/**
 * send request via REDUX.
 */
export const makeReduxOpenModal = (): UsecaseReduxOpenModal =>
  new ReduxOpenModal();
